import { repository } from '@/api/base'

export default {
  async findById(id) {
    const { data } = await repository.get(`/dictionary/disciplineGenerated/${id}`)
    return data
  },
  async checkDiscipline() {
    const { data } = await repository.get('/dictionary/disciplineGenerated/checkDiscipline')
    return data
  },

  async findAll(pageNumber = 0, filters = {}, options = {}) {
    const { data } = await repository.post(`/dictionary/disciplineGenerated/findAll/${pageNumber}`, filters, {
      signal: options.signal
    })
    return data
  },

  async update(body) {
    const { data } = await repository.patch('/dictionary/disciplineGenerated/linkWithOriginalDiscipline', body)
    return data
  },

  async delete(id) {
    const { data } = await repository.delete(`/dictionary/disciplineGenerated/unlinkOriginalDiscipline/${id}`)
    return data
  }
}
